'use strict';

module.exports = [function () {
        return {
            restrict: 'E',
            template: require('./situationRecordNavBar.html'),
            scope: {
                nodeList: "=",
                menuStatus: "=",
                nodeSelect: '&onNodeSelect'
            },

            controller: require('./navBarMasterCtrl.js'),

            link: function (scope) {
                
            }
        };
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/directives/situationRecordNavBar/situationRecordNavBar.js
// module id = 262
// module chunks = 0